export default function () {

    function initT1Navigation() {
        console.log('init navigation');

        var $trigger = $('.t1-nav .has-menu'); // only items with class .has-menu will trigger
        var $menu = $('.t1-menu-container .collapsed-menu');
        var $close = $('.t1-menu-container .close-menu');
        var $body = $('body');
        var $menuContainer = $('.t1-menu-container');

        // close menu function
        function closeNavMenu(e) {
            $menu.slideUp(function () {
                $menu.removeClass('menu-open');
                $('.t1-nav .has-menu.active a').focus();
                $trigger.removeClass('active');
                $trigger.find('> a').attr('aria-expanded', 'false'); // accessibility
            });
            $body.removeClass('menu-is-open');
            $menuContainer.removeClass('menu-spacing');
            
            e.preventDefault();
        }

        // Focus Trap
        $menuContainer.on('keydown', function (event) {
            if (event.which == 9) {
                var tabbableElements = $menuContainer.find('a[href]:visible, area[href], input:not([disabled]):visible, select:not([disabled]):visible, textarea:not([disabled]):visible, button:not([disabled]):visible, iframe:visible, [tabindex]:visible, [contentEditable=true]:visible');
                var thisElementIndex = -1;
                if (event.shiftKey) {
                    thisElementIndex =  tabbableElements.index(document.activeElement);
                    //if this element is the first one in the tabbable elements, then we need to go back to the last element.
                    if (thisElementIndex == 0) {
                        event.preventDefault();
                        $(tabbableElements.get(tabbableElements.length - 1)).focus();
                    }
                } else {
                    //if this element is the last one in the tabbable elements, then we need to go back to the first element.
                    thisElementIndex =  tabbableElements.index(document.activeElement);
                    if (thisElementIndex == tabbableElements.length - 1) {
                        event.preventDefault();
                        $(tabbableElements.get(0)).focus();
                    }
                }
            }
        });


        if ($trigger.length > 0) {
            $trigger.on('click', function (e) {
                var $this = $(this);
                var target = $this.find('> a').data('target');
                // check if t1 menu is currently animating - prevent clicks
                if ($trigger.is('.animating')) {
                    e.stopPropagation();
                }
                // check if t1 menu is already open - if it is close menu
                else if ($this.hasClass('active')) {
                    $this.removeClass('active');
                    $this.find('> a').attr('aria-expanded', 'false'); // accessibility
                    $(target).slideUp(function () {
                        $(target).removeClass('menu-open');
                        $body.removeClass('menu-is-open');
                        $menuContainer.removeClass('menu-spacing');
                    });
                }
                // check if t1 menu is open while another nav item is clicked - close current menu and open the new one
                else if ($menu.is('.menu-open:visible')) {
                    // console.log('boom')
                    var $menuOpen = $menu.closest('.menu-open');
                    $trigger.removeClass('active');
                    $trigger.find('> a').attr('aria-expanded', 'false'); // accessibility
                    $this.addClass('animating');
                    $menuOpen.slideUp({
                        complete: function () {
                            $menu.removeClass('menu-open');
                            $(target).slideDown(function () {
                                $(target).addClass('menu-open').focus();
                                $trigger.removeClass('animating');
                            });
                            $this.addClass('active');
                            $this.find('> a').attr('aria-expanded', 'true'); // accessibility
                        }
                    });
                }
                // open targeted menu
                else {
                    $this.addClass('animating');
                    $(target).slideDown(function () {
                        $(target).addClass('menu-open').focus();
                        $trigger.removeClass('animating');
                        $('.t1-menu-container .nav-content a').focus();
                    });
                    $body.addClass('menu-is-open');
                    $menuContainer.addClass('menu-spacing');
                    $this.addClass('active');
                    $this.find('> a').attr('aria-expanded', 'true'); // accessibility

                    // Add ESC key functionality to close visible menu
                    $(document).keyup(function (e) {
                        if (e.keyCode === 27) {
                            closeNavMenu();
                        }
                        e.preventDefault();
                    });
                }
                e.preventDefault();
            });

            // close menu
            $close.on('click', closeNavMenu);
        }
    }

    function initHamburgerNavigation(){

        var $menuTrigger = $('.t1-nav .mobile-menu'); // mobile hamburg trigger
        var $linkTrigger = $('.mobile-t1-nav .has-menu'); // only items with class .has-menu will trigger
        var $menuContainer = $('#mobileMenu');
        var $menu = $('.nav-content .mobile-t1-nav .collapsed-menu');
        var $close = $('.t1-nav .mobile-menu > a');

        function closeMobileNavMenu(e){
            $menuContainer.slideUp(function() {
                $menuContainer.removeClass('menu-open');
                $menuTrigger.removeClass('animating');
                $menuTrigger.removeClass('active');
                $menuTrigger.find('> a').attr('aria-expanded', 'false');
            });
            e.preventDefault();
        }

        if ($menuTrigger.length > 0) {
            $menuTrigger.on('click', function (e) {
                var $this = $(this);
                var target = $this.data('target');
                if($menuTrigger.is('.animating')){
                    event.stopPropagation();
                }

                else if ($this.hasClass('active')){
                    $this.removeClass('active');
                    $this.attr('aria-expanded', 'false');
                    $(target).slideUp(function() {
                        $(target).removeClass('menu-open');
                    });

                } else if ($menuContainer.is('.menu-open:visible')) {
                    var $menuOpen = $menuContainer.closest('.menu-open');
                    $menuTrigger.removeClass('active');
                    $menuTrigger.find('> a').attr('aria-expanded', 'false');
                    $this.addClass('animating');

                    $menuOpen.slideUp({
                        complete: function (){
                            $menuContainer.removeClass('menu-open');
                            $(target).slideDown(function () {
                                $(target).addClass('menu-open').focus();
                                $menuTrigger.removeClass('animating');
                            });
                        }
                    });

                } else {
                    $this.addClass('animating');
                    $(target).slideDown(function(){
                        $(target).addClass('menu-open').focus();
                        $menuTrigger.removeClass('animating');
                    });
                    $this.addClass('active');
                    $this.attr('aria-expanded', 'true');
                }
                e.preventDefault();
            });

            $linkTrigger.find('> a').on('click', function (e) {
                var $this = $(this).parent();
                var target = $this.find('> a').data('target');
                if($linkTrigger.is('.animating')){
                    event.stopPropagation();
                }
                else if ($this.hasClass('active')){
                    $this.removeClass('active');
                    $this.find('> a').attr('aria-expanded', 'false');
                    $(target).slideUp(function() {
                        $(target).removeClass('sub-menu-open');
                    });
                } else if ($menu.is('.sub-menu-open:visible')) {
                    var $menuOpen = $menu.closest('.sub-menu-open');
                    $linkTrigger.removeClass('active');
                    $linkTrigger.find('> a').attr('aria-expanded', 'false');
                    $this.addClass('animating');
                    $menuOpen.slideUp({
                        complete: function (){
                            $menu.removeClass('sub-menu-open');
                            $(target).slideDown(function () {
                                $linkTrigger.removeClass('animating');
                                $(target).addClass('sub-menu-open').focus();
                            });
                            $this.addClass('active');
                            $this.find('> a').attr('aria-expanded', 'true');
                        }
                    });
                }
                else {
                    $this.addClass('animating');
                    $(target).slideDown(function() {
                        $(target).addClass('sub-menu-open').focus();
                        $linkTrigger.removeClass('animating');
                    });
                    $this.addClass('active');
                    $this.find('> a').attr('aria-expanded', 'true');
                }
                e.preventDefault();

            });
            $close.on('click', closeMobileNavMenu);
        }

    }

    function initHamburgerNavigationMicro(){

        var $menuTrigger = $('.mc-mobile-nav .mc-mobile-trigger'); // mobile hamburg trigger
        var $linkTrigger = $('.mobile-t1-nav .has-menu'); // only items with class .has-menu will trigger
        var $menuContainer = $('#mobileMenu');
        var $menu = $('.nav-content .mobile-t1-nav .collapsed-menu');
        var $close = $('.mc-mobile-nav .mc-mobile-trigger > a');

        function closeMobileNavMenu(e){
            $menuContainer.slideUp(function() {
                $menuContainer.removeClass('menu-open');
                $menuTrigger.removeClass('animating');
                $menuTrigger.removeClass('active');
                $menuTrigger.find('> a').attr('aria-expanded', 'false');
            });
            e.preventDefault();
        }

        if ($menuTrigger.length > 0) {
            $menuTrigger.on('click', function (e) {
                var $this = $(this);
                var target = $this.data('target');
                if($menuTrigger.is('.animating')){
                    event.stopPropagation();
                }

                else if ($this.hasClass('active')){
                    $this.removeClass('active');
                    $this.attr('aria-expanded', 'false');
                    $(target).slideUp(function() {
                        $(target).removeClass('menu-open');
                    });

                } else if ($menuContainer.is('.menu-open:visible')) {
                    var $menuOpen = $menuContainer.closest('.menu-open');
                    $menuTrigger.removeClass('active');
                    $menuTrigger.find('> a').attr('aria-expanded', 'false');
                    $this.addClass('animating');

                    $menuOpen.slideUp({
                        complete: function (){
                            $menuContainer.removeClass('menu-open');
                            $(target).slideDown(function () {
                                $(target).addClass('menu-open').focus();
                                $menuTrigger.removeClass('animating');
                            });
                        }
                    });

                } else {
                    $this.addClass('animating');
                    $(target).slideDown(function(){
                        $(target).addClass('menu-open').focus();
                        $menuTrigger.removeClass('animating');
                    });
                    $this.addClass('active');
                    $this.attr('aria-expanded', 'true');
                }
                e.preventDefault();
            });

            $linkTrigger.find('> a').on('click', function (e) {
                var $this = $(this).parent();
                var target = $this.find('> a').data('target');
                if($linkTrigger.is('.animating')){
                    event.stopPropagation();
                }
                else if ($this.hasClass('active')){
                    $this.removeClass('active');
                    $this.find('> a').attr('aria-expanded', 'false');
                    $(target).slideUp(function() {
                        $(target).removeClass('sub-menu-open');
                    });
                } else if ($menu.is('.sub-menu-open:visible')) {
                    var $menuOpen = $menu.closest('.sub-menu-open');
                    $linkTrigger.removeClass('active');
                    $linkTrigger.find('> a').attr('aria-expanded', 'false');
                    $this.addClass('animating');
                    $menuOpen.slideUp({
                        complete: function (){
                            $menu.removeClass('sub-menu-open');
                            $(target).slideDown(function () {
                                $linkTrigger.removeClass('animating');
                                $(target).addClass('sub-menu-open').focus();
                            });
                            $this.addClass('active');
                            $this.find('> a').attr('aria-expanded', 'true');
                        }
                    });
                }
                else {
                    $this.addClass('animating');
                    $(target).slideDown(function() {
                        $(target).addClass('sub-menu-open').focus();
                        $linkTrigger.removeClass('animating');
                    });
                    $this.addClass('active');
                    $this.find('> a').attr('aria-expanded', 'true');
                }
                e.preventDefault();

            });
            $close.on('click', closeMobileNavMenu);
        }

    }



    initT1Navigation();
    initHamburgerNavigation();
    initHamburgerNavigationMicro();
};



// WEBPACK FOOTER //
// ./src/ui/js/apps/navigation.js